import React, { useState } from 'react';
import { parseISO, formatDistance } from 'date-fns'
import { MoreHorizontal, Globe, EyeOff, MessageCircle, Share2, ThumbsUp } from 'react-feather';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import pt from 'date-fns/locale/pt'

import './style.css';
import defaultImage from '../../assets/default.jpg';

function CardPost({ user_id, name, url_avatar, url_image, post_id, text, visible, created_at, liked }) {

    const [isLiked, setIsLiked] = useState(false)
    const [like, setLike] = useState(0)
    const firstDate = parseISO(created_at)
    const distance = formatDistance(firstDate, new Date(), { addSuffix: true, locale: pt })

    async function likeHandler() {
        setLike(isLiked ? like - 1 : like + 1)
        setIsLiked(!isLiked)
    }

    toast.configure()

    return (
        <article className="post">
            <input type="hidden" name="id" value={post_id} />
            <div className="post-top">
                <div className="post-avatar">
                    {url_avatar !== ''
                        ?
                        <img src={url_avatar} alt="avatar" />
                        :
                        <img src={defaultImage} alt="avatar" />
                    }
                </div>
                <div className="post-info">
                    <div className="post-info-name">
                        <a href={`/profile/${1}`}>{name}</a>
                        {visible ?
                            <Globe width="14" color="#8B8B8B" />
                            :
                            <EyeOff width="14" color="#8B8B8B" />
                        }
                    </div>
                    <p>{distance}</p>
                </div>
                <div className="post-action">
                    <div className="post-action-menu">
                        <button>
                            <MoreHorizontal />
                        </button>
                    </div>

                </div>
            </div>
            {text !== "" &&
                (
                    <div className="post-content-text">
                        <p>{text}</p>
                    </div>
                )
            }

            {url_image !== "" &&
                (
                    <div className="post-content-image">
                        <img src={url_image} alt="" />
                    </div>
                )
            }

            <div className="post-details">
                <div className='info-likes'>
                    <div className='like-icon-rounded'>
                        <ThumbsUp width="20" height="20" />
                    </div>
                    <span>{`${like} Curtida(s)`}</span>
                </div>

                <p>0 comentários</p>
            </div>

            <div className="post-bottom">
                <button
                    className={isLiked ? 'like-action-div post-action-button liked' : 'like-action-div post-action-button'}
                    onClick={() => likeHandler()}
                >
                    <ThumbsUp width="24" height="24" />
                    <span>{isLiked ? 'Curtido' : 'Curtir'}</span>
                </button>

                <button className='post-action-button'>
                    <MessageCircle width="24" height="24" />
                    <span>Comentar</span>
                </button>

                <button className='post-action-button'>
                    <Share2 width="24" height="24" />
                    <span>Compartilhar</span>
                </button>
            </div>

        </article>
    )
}

export default CardPost;